module.exports = Em.Handlebars.compile("<div class=\"name\">\n    {{inferredName}}\n</div>\n<div class=\"form-ct\">\n    {{yield}}\n</div>\n");